import React from 'react';

const ComparisonRow = ({ text, hashiaidHas, othersHave }) => {
  return (
    <div 
      className="flex items-start gap-4 py-3 border-b last:border-b-0"
      style={{ borderColor: '#eee' }}
    >
      <div className="flex-1 text-sm leading-relaxed" style={{ color: '#333' }}>
        {text}
      </div>
      <div className="flex gap-8 flex-shrink-0">
        {/* Hashi-aid indicator */}
        <div className="w-12 flex justify-center">
          <div 
            className={`w-4 h-4 rounded-full ${hashiaidHas ? '' : 'border-2'}`}
            style={{ 
              background: hashiaidHas ? 'linear-gradient(135deg, #7874F8 0%, #09C9E9 100%)' : 'transparent',
              borderColor: '#ddd',
              boxShadow: hashiaidHas ? '0 0 10px rgba(120, 116, 248, 0.3)' : 'none'
            }}
          ></div>
        </div>
        {/* Others indicator */}
        <div className="w-12 flex justify-center">
          <div 
            className={`w-4 h-4 rounded-full ${othersHave ? '' : 'border-2'}`}
            style={{ 
              background: othersHave ? 'linear-gradient(135deg, #7874F8 0%, #09C9E9 100%)' : 'transparent',
              borderColor: '#ddd'
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

const Step8 = ({ data, onSelect, overrides }) => {
  const comparisons = [
    { text: 'Clinically studied thyroid-support nutrients', hashiaidHas: true, othersHave: false },
    { text: 'Bioavailable mineral forms', hashiaidHas: true, othersHave: false },
    { text: 'Third-party tested for purity and heavy metals', hashiaidHas: true, othersHave: false },
    { text: 'Free from common fillers and allergens', hashiaidHas: true, othersHave: false },
  ];

  return (
    <div className="flex flex-col">
      {/* Heading */}
      <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-8" style={{ color: '#1a1a2e' }}>
        Here's how <span className="gradient-text">Hashi-aid</span> stacks up.
      </h1>

      {/* Comparison Card */}
      <div 
        className="rounded-xl border overflow-hidden"
        style={{ 
          borderColor: '#e8e8e8',
          background: '#fafafa'
        }}
      >
        {/* Header row */}
        <div 
          className="flex items-center gap-4 px-4 py-3 border-b"
          style={{ 
            borderColor: '#e8e8e8',
            background: 'linear-gradient(135deg, rgba(120, 116, 248, 0.08) 0%, rgba(9, 201, 233, 0.08) 100%)'
          }}
        >
          <div className="flex-1"></div>
          <div className="flex gap-8 flex-shrink-0">
            <div className="w-12 text-center">
              <span className="text-xs font-medium gradient-text">Hashi-aid</span>
            </div>
            <div className="w-12 text-center">
              <span className="text-xs font-medium" style={{ color: '#999' }}>Others</span>
            </div>
          </div>
        </div>
        
        {/* Comparison rows */}
        <div className="px-4">
          {comparisons.map((item, index) => (
            <ComparisonRow
              key={index}
              text={item.text}
              hashiaidHas={item.hashiaidHas}
              othersHave={item.othersHave}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Step8;
